import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import bannerGame from "../../assets/images/banner-games.png";

const Layout = ({ children, activeRoute }) => (
  <Container fluid className="position-relative">
    <Header />
    <Row className="content">
      <Sidebar activeRoute={activeRoute}/>
        <div className="bannerImage">
          <img src={bannerGame}/>
      </div>
      {children}
    </Row>
    <Footer />
  </Container>
);

export default Layout;
